var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('MeetingHeader'),_c('div',{staticClass:"ResultBox"},[_c('Result',{attrs:{"Orders":_vm.orders,"goPayText":"重新支付","goOtherText":"再次预约"},on:{"go":_vm.go}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }